import Vue from 'vue';
import Router from 'vue-router';

import Result from './views/Result';
import NegativeResult from './views/NegativeResult';
import ErrorPage from './views/ErrorPage';
import BeginSigning from './views/signing/BeginSigning';
import NavigateToSigning from './views/signing/NavigateToSigning';
import HandleCallback from './views/signing/HandleCallback';
import CorpHpNavigateToSigning from '@/views/signing/CorpHpNavigateToSigning.vue';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    // Camunda task routes match Camunda task names
    // Each task must have an unique URL
    {
      path: '/result',
      name: 'viewNegativeThankYou',
      component: NegativeResult,
      props: { definitionKey: 'viewNegativeThankYou' },
      meta: { disableSessionExpiration: true },
    },
    {
      path: '/result2',
      name: 'viewUndecidedThankYou',
      component: Result,
      props: { definitionKey: 'viewUndecidedThankYou' },
      meta: { disableSessionExpiration: true },
    },

    // Signicat signing
    {
      path: '/beginSigning',
      name: 'beginSigning',
      component: BeginSigning,
      meta: { disableSessionExpiration: true },
    },
    {
      path: '/applicantSigning',
      name: 'applicantSigning',
      component: NavigateToSigning,
      meta: { disableSessionExpiration: true },
    },
    {
      path: '/coApplicantSigning',
      name: 'coApplicantSigning',
      component: NavigateToSigning,
      meta: { disableSessionExpiration: true },
    },
    {
      path: '/signing/signicat/callback',
      name: 'callbackSigning',
      component: HandleCallback,
      meta: { disableSessionExpiration: true },
    },
    {
      path: '/relatedPersonSigning',
      name: 'relatedPersonSigning',
      component: CorpHpNavigateToSigning,
      meta: { disableSessionExpiration: true },
    },

    // Frontend supporting routes
    {
      path: '/maintenance',
      name: 'maintenance',
      component: ErrorPage,
      props: { errorType: 'maintenance' },
      meta: { disableSessionExpiration: true },
    },
    {
      path: '/error',
      name: 'error500',
      component: ErrorPage,
      props: { errorType: 'error500' },
      meta: { disableSessionExpiration: true },
    },
    {
      path: '/session-expired',
      name: 'sessionExpired',
      component: ErrorPage,
      props: { errorType: 'session-expired' },
      meta: { disableSessionExpiration: true },
    },
    {
      path: '/unauthorized',
      name: 'unauthorized',
      component: ErrorPage,
      props: { errorType: 'unauthorized' },
      meta: { disableSessionExpiration: true },
    },
    {
      path: '/no-task',
      name: 'noTask',
      component: ErrorPage,
      props: { errorType: 'no-account' },
    },
    {
      path: '/no-process',
      name: 'noProcess',
      component: ErrorPage,
      props: { errorType: 'no-account' },
      meta: { disableSessionExpiration: true },
    },
    {
      path: '*',
      name: 'error404',
      component: ErrorPage,
      props: { errorType: 'error404' },
      meta: { disableSessionExpiration: true },
    },
  ],
  scrollBehavior() {
    return {
      x: 0,
      y: 0,
    };
  },
});

export default router;
